import {AppState} from '../../configStore';

export const selectLocalAddressRoot = (state: AppState) => state.localAddress;
